export const isImage = fileName => {
  return imageExtensions.includes(fileName.split(".").pop());
};

const imageExtensions = [
  "jpg",
  "png",
  "bmp",
  "jpeg",
  "jpe",
  "jfif",
  "git",
  "tif",
  "tiff",
  "wmf",
  "emf",
  "ico",
  "webp",
];
